<template>
  <div
    id="main-wrapper"
    data-sidebar-position="fixed"
    data-header-position="fixed"
  >
    <headerlogo></headerlogo>
    <subheaderoptions></subheaderoptions>
    <div class="page-wrapper">
      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-md-auto align-self-center">
            <h4 class="page-title">
              {{ menu.opcion.name }}
              <span v-if="menu.buttons.help.mostrar" id="breadcrumb_help">
              </span>
            </h4>
            <div class="d-flex align-items-center"></div>
          </div>
          <div class="col-auto d-md-block d-none form-inline ml-auto">
            <div class="row">
              <div
                class="col-auto input-group ml-auto"
                v-show="menu.filtros.fechas.mostrar"
              >
                <div class="row" id="timePicker">
                  <div class="col-auto">
                    <label for="fecha_inicial_menu">{{ $t("page.general.fecha_inicial") }}</label>
                    <b-form-datepicker
                      v-model="menu.filtros.fechas.fecha_inicial"
                      aria-label="Fecha Inicial"
                      class="form-group"
                      id="fecha_inicial_menu"
                    ></b-form-datepicker>
                  </div>
                  <div class="col-auto">
                    <label for="fecha_final_menu">{{ $t("page.general.fecha_final") }}</label>
                    <b-form-datepicker
                      type="text"
                      aria-label="Fecha Final"
                      v-model="menu.filtros.fechas.fecha_final"
                      class="form-control"
                      id="fecha_final_menu"
                    ></b-form-datepicker>
                  </div>
                </div>
              </div>
              <div class="col-auto form-inline text-right">
                <button
                  class="btn btn_blue ml-auto mr-1"
                  v-on:click="Actualizar_Consulta"
                  id="Consultar_Button"
                  v-if="menu.buttons.consultar"
                >
                  {{ menu.buttons.consultar_name }}
                </button>
                <button
                  class="btn btn-danger mr-1"
                  id="Nuevo_Button"
                  v-if="menu.buttons.nuevo"
                >
                  {{ menu.buttons.nuevo_name }}
                </button>
                <button
                  class="btn btn-danger mr-1"
                  id="button_action_rnd"
                  v-if="menu.buttons.action_button"
                >
                  {{ menu.buttons.action_button_text }}
                </button>
                <button
                  class="btn btn-success mr-1"
                  v-if="menu.buttons.excel"
                  v-on:click="Excel"
                >
                  <div v-if="!menu.excel.buscando">{{ $t("page.general.exportar") }}</div>
                  <div v-else>
                    <div class="d-flex justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">{{ $t("page.general.cargar") }}</span>
                      </div>
                    </div>
                  </div>
                </button>
                <button
                  id="Imprimir_Button"
                  class="btn btn-warning"
                  v-if="menu.buttons.imprimir"
                >
                  {{ $t("page.general.imprimir") }}
                </button>
                <button
                  id="crear_puesto_Button"
                  class="btn btn-danger"
                  data-target="#crear_puesto_modal"
                  v-if="menu.buttons.crear_puesto"
                  @click="showModalCrearPuesto()"
                >
                  {{ $t("page.general.crear_puesto") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-auto col-12 align-self-center">
            <div class="d-flex no-block justify-content-end align-items-center">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li
                    class="breadcrumb-item"
                    v-if="menu.opcion.origin1.name.length > 0"
                  >
                    {{ menu.opcion.origin1.name }}>
                  </li>
                  <li
                    class="breadcrumb-item"
                    v-if="menu.opcion.origin2.name.length > 0"
                  >
                    {{ menu.opcion.origin2.name }}
                  </li>
                  <li
                    class="breadcrumb-item"
                    v-if="menu.opcion.origin3.name.length > 0"
                  >
                    {{ menu.opcion.origin3.name }}
                    >
                  </li>
                  <li
                    class="breadcrumb-item active"
                    v-if="menu.opcion.mostrar_name"
                    aria-current="page"
                  >
                    {{ menu.opcion.name }}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid px-3">
        <div class="row">
          <div class="col-md-12">
            <div class="panel panel-default">
              <div class="panel-body">
                <router-view> </router-view>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <menufunctions></menufunctions>

    <button
      type="button"
      id="button_modal_ver_notificacion"
      class="btn btn-primary d-none"
      data-toggle="modal"
      data-target="#modal_ver_notificacion"
    >
       {{ $t("page.general.ver_notificacion") }}
    </button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal_ver_notificacion"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal_ver_notificacionLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal_ver_notificacionLabel">
               {{ $t("page.general.ver_notificacion") }}
            </h5>
            <button
              type="button"
              id="cerrar_modal_ver_notificacion"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <vernotificacion></vernotificacion>
          </div>
        </div>
      </div>
    </div>
    <chat v-if="menu.usuario.cve_empleado != undefined" class="d-none"/>
  </div>
</template>
<script>
import Vue from "vue";
import { mapActions } from "vuex";
import HeaderLogo from "./HeaderLogo.vue";
import SubHeaderOptions from "./SubHeaderOptions.vue";
import Dashboard from "../Dashboard/Dashboard.vue";
import MenuFunctions from "../Functions/Menu.vue";
import VerNotificacion from "./../Notificaciones/Notificacion.vue";
import Chat from "../Chat/Chat.vue";
export default {
  components: {
    headerlogo: HeaderLogo,
    subheaderoptions: SubHeaderOptions,
    dashboard: Dashboard,
    menufunctions: MenuFunctions,
    vernotificacion: VerNotificacion,
    chat: Chat,
  },
  data() {
    return {
      result: "d-none",
      opcion_selected: "General",
    };
  },
  methods: {
    showModalCrearPuesto() {
      $("#crear_puesto_modal").modal();
    },
    ejecutar_ruta(route_name) {
      this.$router.push({ name: route_name });
    },
    Actualizar_Consulta() {
      this.Actualizando_Tabla();
      if (this.datatable != null) {
        this.datatable.tabla_global.search("").columns().search("").draw();
      }
    },
    Imprimir() {
      $("#DivIdToPrint").printThis();
    },
    Excel() {
      //document.querySelector('.dt-button.buttons-excel.buttons-html5').click();
      this.Json_to_Excel();
    },
    Link(name_route) {
      if (name_route != "") {
        this.$router.push({ name: name_route });
      }
    },
    Cargando() {
      var that = this;
      $(document).ready(function () {
        $(".preloader").fadeIn();
        that.result = "d-none";
      });
    },
    Listo() {
      var that = this;
      $(document).ready(function () {
        $(".preloader").fadeOut();
        that.result = "";
      });
    },
    No_Hacer_Nada() {},
    ...mapActions([
      "Actualizar_Token",
      "Json_to_Excel",
      "Actualizando_Tabla",
      "Definir_Tooltip_De_La_Seccion",
    ]),
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    help() {
      return this.$store.getters.getHelp;
    },
    datatable() {
      return this.$store.getters.getDatatable;
    },
  },
  watch: {
    help: function (val) {
      this.Definir_Tooltip_De_La_Seccion();
    },
  },
  created() {
    if (this.$route.params.origin != undefined) {
      location.reload();
    } else {
      this.Listo();
      if (this.$route.name != "Descargar_ICS") {
        if (this.$route.name != "Menu") {
          this.ejecutar_ruta(this.$route.name);
        } else {
          this.ejecutar_ruta("Dashboard");
        }
      } else {
        $(document).ready(function () {
          $(".preloader").fadeOut();
        });
      }
    }
  },
  mounted() {
    var that = this;
    $("#customizer_color_menu").removeClass("d-none");
    /*
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = "https://static.zdassets.com/ekr/snippet.js?key=5a66cf59-f819-4203-a3fc-8d15b5d308ea";
        s.id = "ze-snippet";
        $("body").append(s);
        */
    this.menu.filtros.fechas.fecha_inicial =
      new Date().toDateInputValue_3Mes_Atras();
    this.menu.filtros.fechas.fecha_final =
      new Date().toDateInputValue_Mes_Siguiente();

    $("#fecha_inicial_menu").datepicker({
      dateFormat: "yy-mm-dd",
    });
    $("#fecha_final_menu").datepicker({
      dateFormat: "yy-mm-dd",
    });
  },
};
</script>

<style scoped>
.spinner-border {
  height: 1.5em;
  width: 1.5em;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.b-form-datepicker {
  display: flex;
  padding: 0;
}
#timePicker /deep/ .b-calendar-inner {
  width: 100% !important;
}

#timePicker /deep/ .dropdown-menu.show {
  width: 150% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Menu/Main_Menu.vue